import {BrowserModule} from "@angular/platform-browser";
import {ErrorHandler, NgModule} from "@angular/core";

import {AppComponent} from "./app.component";
import {LoginPageComponent} from "./pages/login-page/login-page.component";
import {AppRoutingModule} from "./app-routing.module";
import {HttpModule} from "@angular/http";
import {AuthService} from "./services/auth.service";
import {FormsModule} from "@angular/forms";
import {AuthGuardService} from "./services/auth-guard.service";
import { QuestPageComponent } from './pages/quest-page/quest-page.component';
import { NvPageComponent } from './components/nv-page/nv-page.component';
import { NvCollectionComponent } from './components/nv-collection/nv-collection.component';
import {KeyValPipe} from "./pipes/keyval.pipe";
import {NvBlockHeaderComponent} from "./components/nv-block-header/nv-block-header.component";
import {NvCollectionSearchComponent} from "./components/nv-collection/nv-collection-search.component";
import {NvListNavigationComponent} from "./components/nv-list-navigation/nv-list-navigation.component";
import {NvItemIdComponent} from "./components/nv-item-id/nv-item-id.component";
import {NvActionComponent} from "./components/nv-actions/nv-action.component";
import {NvActionsComponent} from "./components/nv-actions/nv-actions.component";
import {NvDocControlsComponent} from "./components/nv-doc-controls/nv-doc-controls.component";
import {NvCheckboxComponent} from "./components/nv-checkbox/nv-checkbox.component";
import {NvStageObjListComponent} from "./components/nv-stages/conditions/nv-stage-obj-list.component";
import {NvStageComponent} from "./components/nv-stages/nv-stage.component";
import {NvStagesComponent} from "./components/nv-stages/nv-stages.component";
import {NvTimeParamsComponent} from "./components/nv-time-params/nv-time-params.component";
import {NvDateTimeComponent} from "./components/nv-datetime/nv-datetime.component";
import {NvSelect2Component} from "./components/nv-select/nv-select2.component";

import {NvRewardsComponent} from "./components/nv-rewards/nv-rewards.component";
import {NvRemoveButtonComponent} from "./components/nv-remove-button/nv-remove-button.component";
import {NvButtonComponent} from "./components/nv-button/nv-button.component";
import {NvRestrictionComponent} from "./components/nv-restrictions/nv-restriction.component";
import {NvRestrictionsComponent} from "./components/nv-restrictions/nv-restrictions.component";
import {NvScenesComponent} from "./components/nv-scenes/nv-scenes.component";
import {NvSceneComponent} from "./components/nv-scenes/nv-scene.component";
import {NvAchievementStageComponent} from "./components/nv-achievement-stages/nv-achievement-stage.component";
import {NvAchievementStagesComponent} from "./components/nv-achievement-stages/nv-achievement-stages.component";
import {NvConditionsComponent} from "./components/nv-condition/nv-conditions.component";
import {NvConditionComponent} from "./components/nv-condition/nv-condition.component";
import {NvSelectComponent} from "./components/nv-select/nv-select.component";
import {NvListIdsComponent} from "./components/nv-list-ids/nv-list-ids.component";
import {NvInput} from "./components/nv-input/nv-input.component";
import {NvLockIndicatorComponent} from "./components/nv-lock-indicator/nv-lock-indicator.component";
import {GoPageRootComponent} from "./pages/go/go-page-root.component";
import {GoWrapperComponent} from "./components/go/go-wrapper/go-wrapper.component";
import {GoResTransactionComponent} from "./components/go/go-res-transaction/go-res-transaction.component";
import {GoWorkComponent} from "./components/go/go-work/go-work.component";
import {GoBoundsComponent} from "./components/go/go-bounds/go-bounds.component";
import {GoLairComponent} from "./components/go/go-lair/go-lair.component";
import {GoShopComponent} from "./components/go/go-shop/go-shop.component";
import {GoInfluenceSenderComponent} from "./components/go/go-influence/go-influence-sender.component";
import {GoHouseComponent} from "./components/go/go-house/go-house.component";
import {GoInitialComponent} from "./components/go/go-initial/go-initial.component";
import {GoLimitedComponent} from "./components/go/go-limited/go-limited.component";
import {GoFloatingCostComponent} from "./components/go/go-floating-cost/go-floating-cost.component";
import {GoPastureComponent} from "./components/go/go-pasture/go-pasture.component";
import {GoResourceComponent} from "./components/go/go-resource/go-resource.component";
import {GoStorageComponent} from "./components/go/go-storage/go-storage.component";
import {GoPlantComponent} from "./components/go/go-plant/go-plant.component";
import {GoMoveComponent} from "./components/go/go-move/go-move.component";
import {NvSectorEditorComponent} from "./components/nv-sector-editor/nv-sector-editor.component";
import {BsModalComponent} from "./bs-modal.component";
import {SelectModalComponent} from "./modals/select-modal.component";
import {GoPageComponent} from "./pages/go/go-page.component";
import {ProfileAttributesPageComponent} from "./pages/attributes/profile.attributes-page.component";
import {GeneratorsLocationPageComponent} from "./pages/location/generators.location-page.component";
import {MapsLocationPageComponent} from "./pages/location/map.location-page.component";
import {LevelsPremiumShopPageComponent} from "./pages/prem_shop/levels.premium-shop.page.component";
import {LotsPremiumShopPageComponent} from "./pages/prem_shop/lots.premium-shop.page.component";
import {DropAttributesPageComponent} from "./pages/attributes/drop.attributes-page.component";
import {LevelsAttributesPageComponent} from "./pages/attributes/levels.attributes-page.component";
import {OffersPageComponent} from "./pages/offers/offers-page.component";
import {AchievementsPageComponent} from "./pages/achievements/achievements-page.component";
import {SpellPageComponent} from "./pages/spells/spells-page.component";
import {BuffsPageComponent} from "./pages/buffs/buffs-page.component";
import {HomePageComponent} from "./pages/home/home-page.component";
import {TestComponent} from "./pages/test/test.component";
import {StoryComponent} from "./pages/stories/stories-page.component";
import {NvTabComponent} from "./components/nv-tabs/nv-tab.component";
import {NvTabsComponent} from "./components/nv-tabs/nv-tabs.component";
import {NvPreloaderDirective} from "./directives/preloader.directive";
import {NvDisabledDirective} from "./directives/nv-disabled.directive";
import {FactoryService} from "./services/factory.service";
import {PreloaderService} from "./services/preloader.service";
import {LockService} from "./services/lock.service";
import {SockService} from "./services/sock.service";
import {QueryService} from "./services/query.service";
import {ModalService} from "./services/modal.service";
import {WatchService} from "./services/watch.service";
import {ErrorService} from "./services/error.service";
import {StageService} from "./services/conditionService";
import {DocumentService} from "./services/document.service";
import {CollectionService} from "./services/collection.service";
import {ReportsService} from "./services/reports.service";
import {ObjListService} from "./services/objListService";
import {AppErrorHandler} from "./services/error-handler.service";
import {DateTimePickerModule} from "ng2-date-time-picker";
import {MainPageComponent} from "./pages/main/main-page.component";
import { NvProfilesComponent } from './components/nv-profiles/nv-profiles.component';
import {LoaderService} from "./services/loader.service";
import {ProfilesRootPageComponent} from "./pages/profiles/profiles-root-page.component";
import {ProfilesPageComponent} from "./pages/profiles/profiles-page.component";
import {ProfileService} from "./services/profile.service";
import {BusService} from "./services/bus.service";
import { NvProfileResourcesComponent } from './components/nv-profile-resources/nv-profile-resources.component';
import { NvInputStaticComponent } from './components/nv-input/nv-input-static.component';
import { NvProfileControlsComponent } from './components/nv-profile-controls/nv-profile-controls.component';
import {MapService} from "./services/map.service";
import { SearchPageComponent } from './pages/search-page/search-page.component';
import { NvLocaleComponent } from './components/nv-locale/nv-locale.component';
import { NvLocalesModalComponent } from './modals/nv-locales-modal/nv-locales-modal.component';
import { TextPageComponent } from './pages/text-page/text-page.component';

import { FileDropDirective, FileSelectDirective} from 'ng2-file-upload';
import {PickService} from "./services/pick.service";
import { NvSpineButtonComponent } from './components/nv-spine/nv-spine-button.component';
import { NvSpineModalComponent } from './modals/nv-spine-modal/nv-spine-modal.component';
import {AnimationsService} from "./services/animations.service";
import { NvListComponent } from './components/nv-list/nv-list.component';
import {ResourceMetricsService} from "./services/resource-metrics.service";
import { TexturesPageComponent } from './pages/home/textures-page.component';
import { HomePageRootComponent } from './pages/home/home-page-root.component';
import {HttpService} from "./services/http.service";
import { ConstsPageComponent } from './pages/consts-page/consts-page.component';
import {WeightsAttributesPageComponent} from "./pages/attributes/weights.attributes-page.component";
import { ProfileUtilsPageComponent } from './pages/home/profile-utils-page.component';
import {NvTalksComponent} from "./components/nv-scenes/nv-talks.component";
import {NvSlidesComponent} from "./components/nv-scenes/nv-slides.component";
import {AtlasesComponent} from "./pages/atlases/atlases-page.component";
import { NvAtlasesComponent } from './components/nv-atlases/nv-atlases.component';
import { LogsPageComponent } from './pages/logs/logs-page.component';
import { NvLogsComponent } from './components/nv-logs/nv-logs.component';
import { LogsRootPageComponent } from './pages/logs/logs-root-page.component';
import { LocalesListPageComponent } from './pages/locales-list-page/locales-list-page.component';
import { OnmapDialogsComponent } from './pages/onmap-dialogs/onmap-dialogs.component';
import { NvDirigibleFullRewardComponent } from './components/nv-dirigible-full-reward/nv-dirigible-full-reward.component';
import { NvConfirmModalComponent } from './modals/nv-confirm-modal/nv-confirm-modal.component';
import { NvMessageModalComponent } from './modals/nv-message-modal/nv-message-modal.component';
import { NvLogStatsComponent } from './components/nv-log-stats/nv-log-stats.component';
import { OfferLotsComponent } from './pages/prem_shop/offer-lots.premium-shop-page.component';
import { MonetaryGroupsPageComponent } from './pages/offers-restrictions-groups/monetary-groups-page/monetary-groups-page.component';
import { RecencyGroupsPageComponent } from './pages/offers-restrictions-groups/recency-groups-page/recency-groups-page.component';
import { FrequencyGroupsPageComponent } from './pages/offers-restrictions-groups/frequency-groups-page/frequency-groups-page.component';
import { NvRewardsWithIconsComponent } from './components/nv-rewards-with-icons/nv-rewards-with-icons.component';
import { NvOrderTemplatesComponent } from './components/nv-order-templates/nv-order-templates.component';
import { GoTagsComponent } from './components/go/go-tags/go-tags.component';
import { GoTagsPageComponent } from './pages/go-tags-page/go-tags-page.component';
import { NvGeneratorComponent } from './components/nv-generator/nv-generator.component';
import { NvTagsComponent } from './components/nv-tags/nv-tags.component';
import { GoLiveDecorComponent } from './components/go/go-live-decor/go-live-decor.component';
import { NvProfileInappsComponent } from './components/nv-profile-inapps/nv-profile-inapps.component';
import { NvQuestRewardTemplateComponent } from './components/nv-quest-reward-template/nv-quest-reward-template.component';
import { QuestArcPageComponent } from './pages/quest-arc-page/quest-arc-page.component';
import { NvPictureParamsComponent } from './components/nv-picture-params/nv-picture-params.component';
import { NvLocaleTextareaComponent } from './components/nv-locale-textarea/nv-locale-textarea.component';
import { GameEventPageComponent } from './pages/game-event-page/game-event-page.component';
import { NvGameEventsComponent } from './components/nv-game-events/nv-game-events.component';
import { GoGameEventsComponent } from './components/go/go-game-events/go-game-events.component';
import { GoOrdersComponent } from './components/go/go-orders/go-orders.component';
import { GoEventStarterComponent } from './components/go/go-event-starter/go-event-starter.component';
import { TemplateTypesPageComponent } from './pages/template-types-page/template-types-page.component';
import { GoRenderComponent } from './components/go/go-render/go-render.component';
import { NvRenderComponent } from './components/nv-render/nv-render.component';
import { NvCategoriesListComponent } from './components/nv-categories-list/nv-categories-list.component';
import { AdvertisementComponent } from './pages/advertisement/advertisement.component';
import { NvAdsSettingsComponent } from './components/nv-ads-settings/nv-ads-settings.component';
import { NvAdNetsComponent } from './components/nv-ads-settings/nv-ad-nets.component';
import { AdNetworksComponent } from './pages/ad-networks/ad-networks.component';
import { GeosListPageComponent } from './pages/geos-list-page/geos-list-page.component';
import { OfferTypesListPageComponent } from './pages/offer-types-list-page/offer-types-list-page.component';
import { NvHistoryJournalComponent } from './components/nv-history-journal/nv-history-journal.component';
import {HistoryService} from "./services/history.service";
import { NvHistoryJournalModalComponent } from './modals/nv-history-journal-modal/nv-history-journal-modal.component';
import { NvResourcesListComponent } from './components/nv-resources-list/nv-resources-list.component';
import { NvMetaImportModalComponent } from './modals/nv-meta-import-modal/nv-meta-import-modal.component';
import { NvLoadImgModalComponent } from './modals/nv-load-img-modal/nv-load-img-modal.component';
import { NvLoadImgBtnComponent } from './components/nv-load-img-btn/nv-load-img-btn.component';
import { NvFmanagerBtnComponent } from './components/nv-fmanager-btn/nv-fmanager-btn.component';
import { NvFmanagerModalComponent } from './modals/nv-fmanager-modal/nv-fmanager-modal.component';
import { GoGameTaskComponent } from './components/go/go-game-task/go-game-task.component';
import { GoPeriodicalRewardComponent } from './components/go/go-periodical-reward/go-periodical-reward.component';
import { GoInfluenceReceiverComponent } from './components/go/go-influence-receiver/go-influence-receiver.component';
import { GameEventMapPageComponent } from './pages/game-event-map-page/game-event-map-page.component';
import { NvAdditionalRewardComponent } from './components/nv-additional-reward/nv-additional-reward.component';
import { NvAdsMultipliersComponent } from './components/nv-ads-multipliers/nv-ads-multipliers.component';


@NgModule({
  declarations: [
    AppComponent,
    KeyValPipe,

    // components
    NvPageComponent, NvCollectionComponent, NvInput, NvListIdsComponent, NvSelectComponent,
    NvConditionComponent, NvConditionsComponent,
    NvAchievementStagesComponent, NvAchievementStageComponent,
    NvRestrictionsComponent, NvRestrictionComponent, NvButtonComponent, NvRemoveButtonComponent,
    NvRewardsComponent,
    NvSelect2Component, NvDateTimeComponent, NvTimeParamsComponent,
    NvStagesComponent, NvStageComponent, NvStageObjListComponent, NvCheckboxComponent,
    NvDocControlsComponent, NvActionsComponent, NvActionComponent,
    NvItemIdComponent, NvListNavigationComponent, NvCollectionSearchComponent,
    NvLockIndicatorComponent, NvBlockHeaderComponent, NvTabsComponent, NvTabComponent,
    NvScenesComponent, NvSceneComponent, NvTalksComponent, NvSlidesComponent,

    //directives
    NvPreloaderDirective,
    NvDisabledDirective,

    FileDropDirective,
    FileSelectDirective,



    // go components
    GoWrapperComponent, GoPageRootComponent,
    GoResTransactionComponent, GoWorkComponent,
    GoBoundsComponent, GoLairComponent, GoShopComponent, GoInfluenceSenderComponent,
    GoHouseComponent, GoInitialComponent, GoLimitedComponent,
    GoFloatingCostComponent, GoPastureComponent, GoResourceComponent,
    GoStorageComponent, GoPlantComponent, NvSectorEditorComponent,

    // modals
    BsModalComponent,
    SelectModalComponent,

    // pages
    MainPageComponent, QuestPageComponent, GoPageComponent, TestComponent,
    HomePageComponent, BuffsPageComponent, SpellPageComponent, AchievementsPageComponent,
    OffersPageComponent,
    LevelsAttributesPageComponent, DropAttributesPageComponent, ProfileAttributesPageComponent,
    LotsPremiumShopPageComponent, LevelsPremiumShopPageComponent,
    MapsLocationPageComponent, GeneratorsLocationPageComponent,

    StoryComponent,

    LoginPageComponent,

    ProfilesPageComponent,
    ProfilesRootPageComponent,

    NvProfilesComponent,

    NvProfileResourcesComponent,

    NvInputStaticComponent,

    NvProfileControlsComponent,

    SearchPageComponent,

    NvLocaleComponent,

    NvLocalesModalComponent,

    TextPageComponent,
    NvSpineButtonComponent,
    NvSpineModalComponent,
    NvListComponent,
    TexturesPageComponent,
    HomePageRootComponent,
    ConstsPageComponent,
    WeightsAttributesPageComponent,
    ProfileUtilsPageComponent,
    AtlasesComponent,
    NvAtlasesComponent,
    GoMoveComponent,
    LogsPageComponent,
    NvLogsComponent,
    LogsRootPageComponent,
    LocalesListPageComponent,
    OnmapDialogsComponent,
    NvDirigibleFullRewardComponent,
    NvConfirmModalComponent,
    NvMessageModalComponent,
    NvLogStatsComponent,
    OfferLotsComponent,
    MonetaryGroupsPageComponent,
    RecencyGroupsPageComponent,
    FrequencyGroupsPageComponent,
    NvRewardsWithIconsComponent,
    NvOrderTemplatesComponent,
    GoTagsComponent,
    GoTagsPageComponent,
    NvGeneratorComponent,
    NvTagsComponent,
    GoLiveDecorComponent,
    NvProfileInappsComponent,
    NvQuestRewardTemplateComponent,
    QuestArcPageComponent,
    NvPictureParamsComponent,
    NvLocaleTextareaComponent,
    GameEventPageComponent,
    NvGameEventsComponent,
    GoGameEventsComponent,
    GoOrdersComponent,
    GoEventStarterComponent,
    TemplateTypesPageComponent,
    GoRenderComponent,
    NvRenderComponent,
    NvCategoriesListComponent,
    AdvertisementComponent,
    NvAdsSettingsComponent,
    NvAdNetsComponent,
    AdNetworksComponent,
    GeosListPageComponent,
    OfferTypesListPageComponent,
    NvHistoryJournalComponent,
    NvHistoryJournalModalComponent,
    NvResourcesListComponent,
    GoGameTaskComponent,
    NvResourcesListComponent,
    NvMetaImportModalComponent,
    NvLoadImgModalComponent,
    NvLoadImgBtnComponent,
    NvFmanagerBtnComponent,
    NvFmanagerModalComponent,
    GoPeriodicalRewardComponent,
    GoInfluenceReceiverComponent,
    GameEventMapPageComponent,
    NvAdditionalRewardComponent,
    NvAdsMultipliersComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpModule,
    FormsModule,
    DateTimePickerModule
  ],
  providers: [
    AuthService,
    PickService,
    AuthGuardService,
    CollectionService,
    ProfileService,
    LoaderService,
    DocumentService,
    StageService,
    ObjListService,
    ErrorService,
    WatchService,
    ModalService,
    QueryService,
    SockService, LockService,
    PreloaderService,
    FactoryService,
    HttpService,
    BusService,
    MapService,
    AnimationsService,
    ResourceMetricsService,
    ReportsService,
    HistoryService,
    { provide: ErrorHandler, useClass: AppErrorHandler }
  ],
  bootstrap: [AppComponent],
  entryComponents: [ProfilesRootPageComponent, ProfilesPageComponent, LogsRootPageComponent, LogsPageComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/app.module.ts